export const apiReport = (): string => '/commercial/menuPersonalization/report'
export const apiReportPdf = (): string =>
  '/commercial/menuPersonalization/reportPdf'
export const apiListInstitution = (): string => '/commercial/institutions/'
